import {Injectable} from '@angular/core';
import {ReplenishmentModel} from "../models/ReplenishmentModel";
import {VizixService} from "./vizix.service";
import {Observable} from "rxjs/Observable";
import {Observer} from "rxjs/Observer";
import {DEPARTMENT_NAME_ALL_VALUE} from "../app/app.constants";

@Injectable()
export class ReplenishmentService {
  public replenishmentArray: Array<ReplenishmentModel> = [];
  public replenishmentMap: Map<string, Map<string, ReplenishmentModel>>;
  public column1: string;
  public column2: string;
  public column3: string;
  public column4: string;
  public tag = "[REPLENISHMENT SERVICE]";
  public StoreIDFilterLabel: string;
  public searchPosition: number;
  public lastReplenishmentTaskNumber: number = 0;

  constructor(private _vizixService: VizixService) {

    this.StoreIDFilterLabel = this._vizixService.configurationApp.ReplenishmentConfiguration.StoreIDFilterLabel.value;
    this.searchPosition = this._vizixService.configurationApp.ReplenishmentConfiguration.SearchPosition.value;

  }

  public setColumnNames(column1, column2, column3, column4) {
    this.column1 = column1;
    this.column2 = column2;
    this.column3 = column3;
    this.column4 = column4;
  }

  public setReplenishmentArray(): Observable<any> {
    this.replenishmentMap = new Map();
    return Observable.create((observer: Observer<any>) => {
      const reportBody = {
        [this.StoreIDFilterLabel]: this._vizixService.getStoreId()
      };

      this._vizixService.VizixGetReplenishmentTasks(
        this._vizixService.configurationApp.ReplenishmentConfiguration.ReplenishmentReportId.value, reportBody).subscribe(data => {

          this.setColumnNames(data.columnNames[1] + "/" + data.columnNames[2], data.columnNames[3] + "/" + data.columnNames[4], data.columnNames[5], data.columnNames[6]);
          if (data.data) {
            this.replenishmentArray = [];
            for (let tag of data.data) {
              let replenishmentModel = new ReplenishmentModel(tag[0], tag[1], tag[2], tag[3], tag[4], tag[5], tag[6]);
              this.replenishmentArray.push(replenishmentModel);
            }
          }
          else {
            console.log(this.tag, "not having data array");
          }
          this.lastReplenishmentTaskNumber = data.totalRows;
          observer.next(data);
        },
        err => {
          console.log(this.tag, 'Replenishment ts errorGetConfig', err);
          this.lastReplenishmentTaskNumber= this.replenishmentArray.length;
          observer.error(err);
        },
        () => {
          observer.complete();
        });

    });
  }

  public getReplenishmentList(depatmentId: string): Array<ReplenishmentModel> {
    // return this.replenishmentMap.has(depatmentId) ? Array.from(this.replenishmentMap.get(depatmentId).values()) : [];
    if (depatmentId == DEPARTMENT_NAME_ALL_VALUE) {
      return this.replenishmentArray;
    }
    else {
      return this.replenishmentArray.filter((el) => el.department === depatmentId);
    }
  }


  getDepartmentNamesWithReplenishmentTasks() {
    //Filling unique departments with replenishment tasks
    let departmentList = [];
    departmentList.push({"DeptName": DEPARTMENT_NAME_ALL_VALUE});
    for (let i = 0; i < this.replenishmentArray.length; i++) {
      if (departmentList.findIndex(item => item.DeptName === this.replenishmentArray[i].department) === -1) {
        departmentList.push({"DeptName": this.replenishmentArray[i].department});
      }
    }
    //Sorting depatment list
    return departmentList.sort((a, b) => {
      let x = a.DeptName;
      let y = b.DeptName;
      return ((x < y) ? -1 : ((x > y) ? 1 : 0));
    });
  }


  public DeleteTotallyItem(positionTofilter, valueBasedOnPositionSelectedToSearch) {
    console.log(this.tag, "VALUE BASED ON POSITION TO SEARCH");
    let indexToDelete = this.replenishmentArray.map(x => x[positionTofilter]).indexOf(valueBasedOnPositionSelectedToSearch);
    this.lastReplenishmentTaskNumber--;
    this.replenishmentArray.splice(indexToDelete, 1);
  }

}



// WEBPACK FOOTER //
// ./src/providers/replenishment.service.ts